import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";

const ResidenceDetailPage = () => {
  const [residence, setResidence] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const { id } = useParams(); // Get the residence ID from the URL

  useEffect(() => {
    const fetchResidence = async () => {
      const residenceRef = doc(db, "residences", id);
      const residenceDoc = await getDoc(residenceRef);

      if (residenceDoc.exists()) {
        setResidence(residenceDoc.data());
      } else {
        console.error("Residence not found!");
      }
    };

    fetchResidence();
  }, [id]);

  const handleBooking = async (e) => {
    e.preventDefault();
    alert(`Booking confirmed for ${name} on ${bookingDate}`);
    // You can implement booking logic here
  };

  if (!residence) {
    return <p>Loading residence details...</p>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center mb-6">{residence.name}</h1>
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <img
          src={residence.image}
          alt={residence.name}
          className="w-full h-64 object-cover rounded-md mb-4"
        />
        <p className="text-gray-600">{residence.description}</p>
        <p className="text-gray-500 mt-2">المدينة: {residence.city}</p>
        <p className="text-gray-500">البلد: {residence.country}</p>
        <p className="text-gray-500">النوع: {residence.type}</p>
        <p className="text-xl font-bold text-gray-900 mt-4">نطاق السعر: ${residence.price}</p>
      </div>

      <h2 className="text-2xl font-semibold mt-6 mb-4">حجز الإقامة</h2>
      <form onSubmit={handleBooking} className="bg-white p-6 rounded-lg shadow-lg">
        <div className="mb-4">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            الاسم
          </label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md"
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            البريد الإلكتروني
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md"
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="bookingDate" className="block text-sm font-medium text-gray-700">
            تاريخ الحجز
          </label>
          <input
            type="date"
            id="bookingDate"
            value={bookingDate}
            onChange={(e) => setBookingDate(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full p-3 bg-green-600 text-white rounded-md"
        >
          تأكيد الحجز
        </button>
      </form>
    </div>
  );
};

export default ResidenceDetailPage;
